module.exports = __webpack_public_path__ + "img/sortup.98c00faa.png";